import debug from "debug";
const log = debug("app:fn");

/**
 * Class representing the controller for the Context Menu functionality.
 * Handles interactions and events for the context menu.
 * @category Components
 * @subcategory ContextMenu
 */
class ContextMenuController {
  /**
   * Creates an instance of ContextMenuController.
   * @param {Object} experience - The experience object containing utilities like eventHub and selectionManager.
   */
  constructor(experience) {
    /**
     * The experience object.
     * @type {Object}
     */
    this.experience = experience;

    /**
     * The event hub for managing global events.
     * @type {Object}
     */
    this.eventHub = experience.eventHub;

    /**
     * The selection manager for handling selected objects.
     * @type {Object}
     */
    this.selectionManager = experience.selectionManager;

    this.init();
  }

  /**
   * Initializes the controller by setting up event listeners.
   */
  init() {
    this.setDocumentListeners();
    this.setEventListeners();
  }

  /**
   * Sets up global document event listeners for handling menu item clicks.
   */
  setDocumentListeners() {
    document.addEventListener("click", (event) => {
      const target = event.target.closest("li");
      if (!target) return;

      switch (target.id) {
        case "copyOption":
          this.handleCopyClick();
          break;
        case "pasteOption":
          this.handlePasteClick();
          break;
        case "deleteOption":
          this.handleDeleteClick();
          break;
        case "chooseDiffPart":
          this.handleChooseDiffPartClick();
          break;
        case "moreInfo":
          this.handleMoreInfoClick();
          break;
        case "configurePartNumber":
          this.handleConfigurePartNumberClick();
          break;
        case "productPage":
          this.handleProductPageClick();
          break;
        case "sParam":
          this.handleSParameterPlotClick();
          break;
        case "resetToDefault":
          this.handleResetToDefaultClick();
          break;
        // Add more cases for other options as needed
        default:
          log(`Unhandled click on ${target.id}`);
          break;
      }
    });
  }

  /**
   * Sets up event listeners for the context menu.
   */
  setEventListeners() {
    // Example: Add other event listeners for additional behaviors
    this.eventHub.on("contextMenu:hide", () => {
      this.productData = null;
    });
    this.eventHub.on("contextMenu:show", (productData) => {
      this.productData = productData;
    });
  }

  cleanup() {
    console.log("ContextMenuController cleanup started...");
  
    // 1. Remove document event listeners
    if (this.handleDocumentClick) {
      document.removeEventListener("click", this.handleDocumentClick);
    }
  
    // 2. Remove event listeners from eventHub
    if (this.handleContextMenuHide) {
      this.eventHub.off("contextMenu:hide", this.handleContextMenuHide);
    }
    if (this.handleContextMenuShow) {
      this.eventHub.off("contextMenu:show", this.handleContextMenuShow);
    }
  
    // 3. Clear object references
    this.productData = null;
    this.selectionManager = null;
    this.eventHub = null;
    this.experience = null;
  
    console.log("ContextMenuController cleanup completed.");
  }
  /**
   * Handles the "Copy" menu option click event.
   */
  handleCopyClick() {
    log("Copy option clicked");
    this.eventHub.emit("copyCM");

    // Enable Paste option globally
    this.eventHub.emit("contextMenu:enablePaste");
  }

  /**
   * Handles the "Paste" menu option click event.
   */
  handlePasteClick() {
    log("Paste option clicked");
    this.eventHub.emit("contextMenu:paste");
    this.eventHub.emit("pasteCM");
  }

  /**
   * Handles the "Delete" menu option click event.
   */
  handleDeleteClick() {
    log("delete option clicked");
    this.eventHub.emit("deleteCM");
  }

  /**
   * Handles the "Choose Different Part" menu option click event.
   */
  handleChooseDiffPartClick() {
    log("choose diff part option clicked");
    this.eventHub.emit("chooseDiffPart");
  }

  /**
   * Handles the "More Information" menu option click event.
   */
  handleMoreInfoClick() {
    log("choose diff part option clicked");
    this.eventHub.emit("moreInformation");
  }

  /**
   * Handles the "Configure Part Number" menu option click event.
   */
  handleConfigurePartNumberClick() {
    log("choose diff part option clicked");
    this.eventHub.emit("configurePN");
  }

  /**
   * Handles the "Product Page" menu option click event.
   */
  handleProductPageClick() {
    log("choose diff part option clicked");
    log("productdata", this.productData);
    const landingPage = this.productData?.landingPage;
    const fallbackPage =
      "https://catalog.quanticxmw.com/category/all-categories";
    const targetPage = landingPage || fallbackPage;
    window.open(targetPage, "_blank");
  }

  /**
   * Handles the "S-Parameter Plot" menu option click event.
   */
  handleSParameterPlotClick() {
    log("sparam plot clicked");

    const sParamURL = this.productData?.models[0]?.dataURL;
    log("productdata", this.productData);
    log("productdata", this.productData.models[0]);
    log("sParamURL", sParamURL);

    if (sParamURL) {
      this.eventHub.emit("showSParameterModal", sParamURL);
    } else {
      log("No sParamURL available, disabling sParam element");
    }
  }

  /**
   * Handles the "Reset to Default" menu option click event.
   */
  handleResetToDefaultClick() {
    log("choose diff part option clicked");
    this.eventHub.emit("resetConfigured");
  }
}

export default ContextMenuController;
